import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Airplane } from "@phosphor-icons/react/Airplane";

export function HowItWorks() {
	return (
		<div>
			<Container
				maxWidth="lg"
				sx={{ py: "120px" }}>
				<Stack spacing={8}>
					<Container
						maxWidth="lg"
						sx={{ position: "relative", zIndex: 2 }}>
						<Box
							component="img"
							src="https://mangomap.com/_next/image?url=%2Fnew-mangomap-assets%2FmangoGIS.png&w=1080&q=75"
							sx={{
								display: "block",
								height: "auto",
								position: "relative",
								width: "100%",
								zIndex: 2,
							}}
						/>
					</Container>
					<Container maxWidth="lg">
						<Stack
							direction="column"
							spacing={3}
							sx={{
								flexWrap: "wrap",
								justifyContent: "center",
								alignItems: "center",
							}}
							useFlexGap>
							<Stack
								direction={{ xs: "column", sm: "row" }}
								spacing={3}
								sx={{
									justifyContent: "space-evenly",
									alignItems: "stretch",
									flexWrap: "wrap",
								}}
								useFlexGap>
								<Card
									raised
									sx={{
										flex: { xs: "1 1 100%", md: "1 1 30%" },
										maxWidth: { xs: "100%", md: "30%" },
									}}>
									<CardContent>
										<Chip
											color="primary"
											icon={<Airplane />}
											label="Step"
											size="small"
											variant="soft"
										/>
										<Typography
											component="div"
											py={2}
											variant="h5">
											Add Your Data
										</Typography>
										<Typography
											color="text.secondary"
											variant="body2">
											Import GIS files fast—prepped and ready with no fuss.
										</Typography>
									</CardContent>
								</Card>
								<Card
									raised
									sx={{
										flex: { xs: "1 1 100%", md: "1 1 30%" },
										maxWidth: { xs: "100%", md: "30%" },
									}}>
									<CardContent>
										<Chip
											color="primary"
											icon={<Airplane />}
											label="Step"
											size="small"
											variant="soft"
										/>
										<Typography
											component="div"
											py={2}
											variant="h5">
											Build Your Maps
										</Typography>
										<Typography
											color="text.secondary"
											variant="body2">
											Style and tweak portals easily—no ESRI headaches required.
										</Typography>
									</CardContent>
								</Card>
								<Card
									raised
									sx={{
										flex: { xs: "1 1 100%", md: "1 1 30%" },
										maxWidth: { xs: "100%", md: "30%" },
									}}>
									<CardContent>
										<Chip
											color="primary"
											icon={<Airplane />}
											label="Step"
											size="small"
											variant="soft"
										/>
										<Typography
											component="div"
											py={2}
											variant="h5">
											Share It Wide
										</Typography>
										<Typography
											color="text.secondary"
											variant="body2">
											Publish trusted maps to your site, keeping everyone happy.
										</Typography>
									</CardContent>
								</Card>
							</Stack>
							<Stack
								direction={{ xs: "column", sm: "row" }}
								spacing={3}
								sx={{
									justifyContent: "space-evenly",
									alignItems: "stretch",
									flexWrap: "wrap",
								}}
								useFlexGap>
								<Card
									raised
									sx={{
										flex: { xs: "1 1 100%", md: "1 1 30%" },
										maxWidth: { xs: "100%", md: "30%" },
									}}>
									<CardContent>
										<Chip
											color="primary"
											icon={<Airplane />}
											label="Step"
											size="small"
											variant="soft"
										/>
										<Typography
											component="div"
											py={2}
											variant="h5">
											Keep It Current
										</Typography>
										<Typography
											color="text.secondary"
											variant="body2">
											Add new data as it comes in. Mango syncs updates instantly
											across all maps, keeping your work fresh without extra
											effort.
										</Typography>
									</CardContent>
								</Card>
								<Card
									raised
									sx={{
										flex: { xs: "1 1 100%", md: "1 1 30%" },
										maxWidth: { xs: "100%", md: "30%" },
									}}>
									<CardContent>
										<Chip
											color="primary"
											icon={<Airplane />}
											label="Step"
											size="small"
											variant="soft"
										/>
										<Typography
											component="div"
											py={2}
											variant="h5">
											Manage Like a Boss
										</Typography>
										<Typography
											color="text.secondary"
											variant="body2">
											Track every project in one place. Add team members, tweak
											access, and stay in control—no clutter, just clarity.
										</Typography>
									</CardContent>
								</Card>
								<Card
									raised
									sx={{
										flex: { xs: "1 1 100%", md: "1 1 30%" },
										maxWidth: { xs: "100%", md: "30%" },
									}}>
									<CardContent>
										<Chip
											color="primary"
											icon={<Airplane />}
											label="Step"
											size="small"
											variant="soft"
										/>
										<Typography
											component="div"
											py={2}
											variant="h5">
											Win Raving Fans
										</Typography>
										<Typography
											color="text.secondary"
											variant="body2">
											Stakeholders love the accessibility and reliability. You
											save time, they stay impressed—building trust that grows
											your reputation.
										</Typography>
									</CardContent>
								</Card>
							</Stack>
						</Stack>
					</Container>
				</Stack>
			</Container>
		</div>
	);
}
